import { render } from "./conferencia-coletor.vue?vue&type=template&id=51ba385b&scoped=true"
import script from "./conferencia-coletor.vue?vue&type=script&lang=js"
export * from "./conferencia-coletor.vue?vue&type=script&lang=js"

import "./conferencia-coletor.vue?vue&type=style&index=0&id=51ba385b&scoped=true&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ba385b"]])

export default __exports__